/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface IAboutDialogFacade {
  closeWindow(): any;
  getUserData(nameOfRequest: string): any;
  openUrl(url: string): Observable<any>;
}

export const ABOUT_DIALOG_FACADE_TOKEN = new InjectionToken<IAboutDialogFacade>('ABOUT_DIALOG_FACADE_TOKEN');
